<template>
  <transition name="toast-info">
    <div class="toast" v-show="theToast">
      <span>{{ msg }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      theToast: false,
      msg: '',
    }
  },
}
</script>

<style lang="less" scoped>
.toast {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 750px;
  display: flex;
  justify-content: center;
  bottom: 5%;
  z-index: 9000;
  span {
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 16px;
    line-height: 38px;
    .sizeColor(24px, #fff);
    display: flex;
    align-items: center;
    padding: 16px 20px;
    max-width: 70%;
    text-align: center;
  }
}
.toast-info-enter-active,
.toast-info-leave-active {
  transition: 0.3s ease-out;
}

.toast-info-enter {
  opacity: 0;
}

.toast-info-leave-to {
  opacity: 0;
}
</style>
